(function () {
    console.log('[MegaFilters] script loaded');
    function buildMobileFacetList(containerEl, filtersJson) {
      if (!containerEl || !filtersJson || !filtersJson.filters) return;

      const filterLabel = containerEl.getAttribute('data-filter-label');
      const limit = parseInt(containerEl.getAttribute('data-filter-limit') || '50', 10);

      const filter = filtersJson.filters.find(f => f.label === filterLabel);
      if (!filter || !filter.values || !filter.values.length) return;

      // The placeholder is inside a <li>. We want to append actual <li> siblings to the tier-3 <ul>.
      const tier3Ul = containerEl.closest('ul.slide-nav__dropdown[data-level="3"]');
      if (!tier3Ul) return;

      // Remove the placeholder wrapper <li> (optional but keeps DOM clean)
      const placeholderLi = containerEl.closest('li.slide-nav__item');

      const max = Math.min(limit, filter.values.length);

      for (let i = 0; i < max; i++) {
        const v = filter.values[i];

        let rawUrl = v.url_to_add || '';
        rawUrl = rawUrl
          .replace('view=filters-json&', '')
          .replace('?view=filters-json', '')
          .replace('&view=filters-json', '');

        const li = document.createElement('li');
        li.className = 'slide-nav__item';

        const a = document.createElement('a');
        a.className = 'slide-nav__link';
        a.href = new URL(rawUrl, window.location.origin).toString();

        const span = document.createElement('span');
        span.textContent = v.label;

        a.appendChild(span);
        li.appendChild(a);
        tier3Ul.appendChild(li);
      }

      if (placeholderLi) placeholderLi.remove();
    }
  // Simple handleize similar to Shopify's
  function handleize(str) {
    return str
      .toString()
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

   // Force full reload when clicking "Clear all filters"
    document.addEventListener(
      'click',
      function (e) {
        const link = e.target.closest('.collection-clear-all');
        if (!link) return;

        // Stop theme's AJAX handler from hijacking the click
        e.preventDefault();
        e.stopImmediatePropagation();

        // Hard navigation to the clean collection URL
        window.location.href = link.href;
      },
      true // capture phase so we run before theme listeners
    );

  const cache = {}; // per-collection cache

  function fetchFilters(collectionHandle) {
    if (cache[collectionHandle]) return Promise.resolve(cache[collectionHandle]);

    return fetch(`/collections/rug-collection?view=filters-json`, {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Filters fetch failed');
        return res.json();
      })
      .then(function (data) {
        cache[collectionHandle] = data;
        return data;
      })
      .catch(function (err) {
        console.warn('[MegaFilters] Failed to load filters for', collectionHandle, err);
        return null;
      });
  }

  function buildColumn(colEl, filtersJson) {
    if (!filtersJson || !filtersJson.filters) return;

    const filterLabel = colEl.getAttribute('data-filter-label');
    const heading = colEl.getAttribute('data-heading') || filterLabel;
    const limit = parseInt(colEl.getAttribute('data-filter-limit') || '20', 10);
    const filterType = colEl.getAttribute('data-filter-type') || 'default';

    const filter = filtersJson.filters.find(function (f) {
      return f.label === filterLabel;
    });

    if (!filter || !filter.values || !filter.values.length) return;

    // Clear any existing content
    colEl.innerHTML = '';

    // Heading
    const titleWrap = document.createElement('div');
    titleWrap.className = 'megamenu__col-title';
    const titleLink = document.createElement('span');
    titleLink.className = 'site-nav__dropdown-link site-nav__dropdown-link--top-level mega-menu-title';
    titleLink.textContent = heading;
    titleWrap.appendChild(titleLink);
    colEl.appendChild(titleWrap);

    const max = Math.min(limit, filter.values.length);

    // For preserving filters
    const currentUrl = new URL(window.location.href);
    const collectionPath = '/collections/' + (filtersJson.handle || '');
    const onSameCollection = currentUrl.pathname.indexOf(collectionPath) === 0;

    for (let i = 0; i < max; i++) {
      const v = filter.values[i];

      // Start from the filter’s own url_to_add
      let rawUrl = v.url_to_add || '';

      // Strip any view=filters-json bits
      rawUrl = rawUrl.replace('view=filters-json&', '')
                    .replace('?view=filters-json', '')
                    .replace('&view=filters-json', '');

      const addUrl = new URL(rawUrl, window.location.origin);

      let finalPath;
      let finalParams;

      if (onSameCollection) {
        // Preserve current filters on the same collection
        finalPath = currentUrl.pathname;
        finalParams = new URLSearchParams(currentUrl.search);
      } else {
        // Coming from home/other pages: just use the filter’s collection path
        finalPath = addUrl.pathname;
        finalParams = new URLSearchParams(addUrl.search);
      }

      // Merge in the new filter params (from addUrl) without losing existing ones
      const addParams = addUrl.searchParams;
      addParams.forEach(function (val, key) {
        if (key === 'view' && val === 'filters-json') return; // ignore
        const existing = finalParams.getAll(key);
        if (!existing.includes(val)) {
          finalParams.append(key, val);
        }
      });

      const search = finalParams.toString();
      const href = finalPath + (search ? '?' + search : '');

      const a = document.createElement('a');
      a.href = href;
      a.className = 'site-nav__dropdown-link';

      if (filterType === 'color') {
        const wrapper = document.createElement('span');
        wrapper.className = 'filter-item filter-item--' + handleize(v.label);

        const swatch = document.createElement('span');
        swatch.className =
          'color-swatch color-swatch--filter color-swatch--' + handleize(v.label);
        swatch.title = v.label;

        const words = v.label.trim().split(/\s+/);
        const fallbackWord = words[words.length - 1] || '';
        swatch.style.backgroundColor = fallbackWord.toLowerCase();

        //wrapper.appendChild(swatch);

        const textSpan = document.createElement('span');
        textSpan.className = 'filter-swatch-label';
        textSpan.textContent = ' ' + v.label;
        wrapper.appendChild(textSpan);

        a.appendChild(wrapper);
      } else {
        a.textContent = v.label;
      }

      colEl.appendChild(a);
    }
  }

  function buildColumnOld(colEl, filtersJson) {
  if (!filtersJson || !filtersJson.filters) return;

  const filterLabel = colEl.getAttribute('data-filter-label');
  const heading = colEl.getAttribute('data-heading') || filterLabel;
  const limit = parseInt(colEl.getAttribute('data-filter-limit') || '20', 10);
  const filterType = colEl.getAttribute('data-filter-type') || 'default';

  const filter = filtersJson.filters.find(function (f) {
    return f.label === filterLabel;
  });

  if (!filter || !filter.values || !filter.values.length) return;

  // Clear any existing content
  colEl.innerHTML = '';

  // Heading
  const titleWrap = document.createElement('div');
  titleWrap.className = 'megamenu__col-title';
  const titleSpan = document.createElement('span');
  titleSpan.className = 'site-nav__dropdown-link site-nav__dropdown-link--top-level mega-menu-title';
  titleSpan.textContent = heading;
  titleWrap.appendChild(titleSpan);
  colEl.appendChild(titleWrap);

  // Values
  const max = Math.min(limit, filter.values.length);
  for (let i = 0; i < max; i++) {
    const v = filter.values[i];

    // 🔧 Clean the URL so we don’t stay on the filters-json view
    let url = v.url_to_add || '';
    url = url.replace('view=filters-json&', '');
    url = url.replace('?view=filters-json', '');
    url = url.replace('&view=filters-json', '');

    const a = document.createElement('a');
    a.href = url;
    a.className = 'site-nav__dropdown-link';

    if (filterType === 'color') {
      const wrapper = document.createElement('span');
      wrapper.className = 'filter-item filter-item--' + handleize(v.label);

      const swatch = document.createElement('span');
      swatch.className = 'filter-swatch';
      wrapper.appendChild(swatch);

      const textNode = document.createTextNode(' ' + v.label);
      wrapper.appendChild(textNode);

      a.appendChild(wrapper);
    } else {
      a.textContent = v.label;
    }

    colEl.appendChild(a);
  }
}


  function initMegaFilters() {
    const cols = document.querySelectorAll('.js-mega-filter-col');
    if (!cols.length) return;

    // Group columns by collection handle
    const groups = {};
    cols.forEach(function (col) {
      const handle = col.getAttribute('data-collection-handle');
      if (!handle) return;
      if (!groups[handle]) groups[handle] = [];
      groups[handle].push(col);
    });

    Object.keys(groups).forEach(function (handle) {
      fetchFilters(handle).then(function (filtersJson) {
        if (!filtersJson) return;
        groups[handle].forEach(function (colEl) {
          buildColumn(colEl, filtersJson);
        });
      });
    });
 
    // Mobile facet lists
    const mobileFacetEls = document.querySelectorAll('.js-mobile-filter-facets');
    if (mobileFacetEls.length) {
      // group by collection handle so we only fetch once per collection
      const groups = {};
      mobileFacetEls.forEach(el => {
        const handle = el.getAttribute('data-collection-handle');
        if (!handle) return;
        (groups[handle] ||= []).push(el);
      });

      Object.keys(groups).forEach(handle => {
        fetchFilters(handle).then(filtersJson => {
          if (!filtersJson) return;
          groups[handle].forEach(el => buildMobileFacetList(el, filtersJson));
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaFilters);

  } else {
    initMegaFilters();
  }
})();